<template>
  <nav class="columns">
    <h1>Crypto</h1>
    <div>
      <button v-if="user" @click="onClick" class="button">Cerrar sesion</button>
    </div>
  </nav>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState(['user']),
  },
  methods: {
    ...mapActions(['signOut']),
    onClick() {
      this.signOut();
    },
  },
  watch: {
    user(value) {
      if (value === null) {
        this.$router.push('/');
      }
    },
  },
};
</script>

<style>
  h1 {
    color: var(--accent);
  }

  nav a {
    color: var(--primary);
  }

  nav a.router-link-exact-active {
    color: var(--accent);
  }

  .columns {
    display: flex;
    flex-flow: row;
    justify-content: space-between;

    margin: 20px 0;
  }

  .button {
    background-color: var(--accent);
    border-radius: 15px;
    border: 0px;
    padding: 5px;
  }
</style>
